import { Injectable } from '@angular/core';
import { StorageConstants } from '../constants/storage.constants';
import { ILoginResponse } from '../models/response/login.response';

@Injectable()
export class StorageService {
  public fromSession: StorageSession;

  constructor() {
    this.fromSession = new StorageSession();
  }

  public exists(key: string): boolean {
    return this.get(key) !== null;
  }

  public get(key: string): string {
    return localStorage.getItem(key);
  }

  public set(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public clear(): void {
    localStorage.clear();
  }

  public session(user: ILoginResponse): void {
    this.set(StorageConstants.token, user.token);
    this.set(StorageConstants.userId, user.user.id.toString());
  }

  public clearSession(): void {
    this.removeItem(StorageConstants.token);
    this.removeItem(StorageConstants.userId);
  }

  public setObject(key: string, value: any): void {
    this.set(key, JSON.stringify(value));
  }

  public getAsObject(key: string): any {
    return JSON.parse(this.get(key));
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public getBoolean(key: string): boolean {
    if (this.exists(key)) {
      return this.get(key) == '1' ? true : false;
    }
    return false;
  }

  public getInt(key: string): number {
    if (this.exists(key)) {
      return this.get(key) == '1' ? 1 : 0;
    }
    return 0;
  }

  public setBoolean(key: string, data: boolean): void {
    var dataString = data ? '1' : '0';
    this.set(key, dataString);
  }

  private getDataByType(storageKey: string): string | object | boolean | null {
    const value = this.get(storageKey);
    if (!value) {
      return null;
    }
    let response: any;
    switch (true) {
      case value.includes('{') && value.includes('}'):
        response = this.getAsObject(storageKey);
        break;
      case value == '1' || value == '0':
        response = this.getBoolean(storageKey);
        break;
      default:
        response = value;
        break;
    }
    return response;
  }
}

class StorageSession {
  public exists(key: string): boolean {
    return this.get(key) !== null;
  }

  public get(key: string): string {
    return sessionStorage.getItem(key);
  }

  public set(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  public clear(): void {
    sessionStorage.clear();
  }

  public setObject(key: string, value: any): void {
    this.set(key, JSON.stringify(value));
  }

  public getAsObject(key: string): any {
    return JSON.parse(this.get(key));
  }

  public removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  public getBoolean(key: string): boolean {
    if (this.exists(key)) {
      return this.get(key) == '1' ? true : false;
    }
    return false;
  }

  public getInt(key: string): number {
    if (this.exists(key)) {
      return this.get(key) == '1' ? 1 : 0;
    }
    return 0;
  }

  private getDataByType(storageKey: string): string | object | boolean | null {
    const value = this.get(storageKey);
    if (!value) {
      return null;
    }

    let response;
    switch (true) {
      case value.includes('{') && value.includes('}'):
        response = this.getAsObject(storageKey);
        break;
      case value == '1' || value == '0':
        response = this.getBoolean(storageKey);
        break;
      default:
        response = value;
        break;
    }
    return response;
  }

  public setRecoveryDeviceData(email: string, password: string, status: string): void {
    const recoveryData = { email, password, status };
    this.setObject(StorageConstants.recoveryDevice, recoveryData);
  }

  public getRecoveryDeviceData(): { email: string; password: string; status: string } | null {
    const data = this.getDataByType(StorageConstants.recoveryDevice);
    return data ? (data as { email: string; password: string; status: string }) : null;
  }
}
